var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2464_60069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 31.9997C24.8373 31.9997 32.0007 24.8363 32.0007 15.9999C32.0007 7.16338 24.8373 0 16.0008 0C7.16436 0 0.000976562 7.16338 0.000976562 15.9999C0.000976562 24.8363 7.16436 31.9997 16.0008 31.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8006 11.4987C25.1149 11.8028 24.3774 12.0084 23.6039 12.1003C24.3936 11.6271 24.9997 10.8784 25.2858 9.98483C24.5468 10.4232 23.728 10.7412 22.8572 10.9126C22.1596 10.1696 21.1656 9.70532 20.065 9.70532C17.9533 9.70532 16.2406 11.418 16.2406 13.5297C16.2406 13.8295 16.2745 14.1213 16.3401 14.4013C13.1617 14.2419 10.3435 12.7194 8.4571 10.4049C8.12796 10.9697 7.93915 11.6271 7.93915 12.3279C7.93915 13.6544 8.61482 14.8255 9.64045 15.5111C9.01383 15.4914 8.42373 15.3194 7.90835 15.0322C7.90807 15.0485 7.90807 15.0648 7.90807 15.0807C7.90807 16.9338 9.22689 18.4793 10.9761 18.8304C10.6555 18.9183 10.317 18.9647 9.96873 18.9647C9.72173 18.9647 9.48244 18.9411 9.24914 18.8966C9.73571 20.4156 11.1478 21.5214 12.8217 21.5525C11.5126 22.5784 9.86377 23.1896 8.07149 23.1896C7.76346 23.1896 7.45829 23.1716 7.15967 23.136C8.85126 24.2215 10.862 24.8544 13.0216 24.8544C20.0561 24.8544 23.9031 19.0269 23.9031 13.9727C23.9031 13.807 23.8994 13.6418 23.8919 13.4781C24.6398 12.9391 25.2881 12.2657 25.8006 11.4987Z",
    fill: "#39455E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2464_60069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c701c2193039cd58a734ca9aa1dd1543.svg";
export { ForwardRef as ReactComponent };